import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export function ScrollToTop() {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}